import type { AuthenticatedUser } from '@fleetcore/shared'
import { useMemo } from 'react'

import { useAuthStore, type AuthStatus, type Credentials } from './auth-store'

export interface UseAuth {
  status: AuthStatus
  user: AuthenticatedUser | null
  isAuthenticated: boolean
  isRestoring: boolean
  isSubmitting: boolean
  errorKey: string | null
  login: (credentials: Credentials) => Promise<boolean>
  logout: () => Promise<void>
  clearError: () => void
}

export function useAuth(): UseAuth {
  const status = useAuthStore((state) => state.status)
  const user = useAuthStore((state) => state.user)
  const errorKey = useAuthStore((state) => state.errorKey)
  const isSubmitting = useAuthStore((state) => state.isSubmitting)
  const login = useAuthStore((state) => state.login)
  const logout = useAuthStore((state) => state.logout)
  const clearError = useAuthStore((state) => state.clearError)

  return useMemo(
    () => ({
      status,
      user,
      isAuthenticated: status === 'authenticated' && user !== null,
      isRestoring: status === 'restoring',
      isSubmitting,
      errorKey,
      login,
      logout,
      clearError,
    }),
    [status, user, isSubmitting, errorKey, login, logout, clearError],
  )
}
